<template>
  <ResizablePage>
    <template v-slot:content="contentProps">
      <v-data-table
        :headers="headers"
        :items="groupSets"
        :items-per-page="-1"
        :height="contentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :custom-filter="customFilter"
        @click:row="rowClick"
        @contextmenu:row="rowMenuClick"
      >
      </v-data-table>
      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <v-list-item v-for="(item, index) in contextItems"
                       :key="index"
                       link
                       @click="rowMenuItemClick(item)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import ResizablePage from "@/components/ResizablePage";

export default {
  name: "GroupSetsView",

  components: { ResizablePage },

  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextPerson: null,
      contextItems: [
      ],

      headers: [
        {
          text: this.$t("table.groupsets.header.name"),
          align: "start",
          sortable: true,
          width: "30%",
          value: "name"
        },
        {
          text: this.$t("table.groupsets.header.note"),
          align: "start",
          sortable: true,
          width: "70%",
          value: "note"
        }
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter
    },

    groupSets: function() {
      if (this.$store.state.data.records === null || this.$store.state.data.module !== "groupset")
        return [];
      else
        return this.$store.state.data.records
    }
  },

  methods: {
    customFilter(value, search, item) {
      let ls = search.toLowerCase()
      return (item.name !== null && item.name.toLowerCase().includes(ls))
        || (item.note !== null && item.note.toLowerCase().includes(ls))
    },

    rowClick(item) {
      this.$router.push({ name: "data/groupset", params: { id: item.groupSetId } });
    },

    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextPerson = item.item;

      event.preventDefault();
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "report-tachograph":
          this.$router.push({
            name: "report/tachograph",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "personId": this.contextPerson.personId, "periodName": "month-current" }
          });
          break;
        case 'report-travel-expenses':
          this.$router.push({
            name: "report/travel-expenses",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "personId": this.contextPerson.personId, "periodName": "month-current" }
          });
          break;
      }
    }
  },

  watch: {
    '$store.state.auth.company': function () {
      if (this.mounted)
        this.$store.dispatch("data/fetchRecords", { module: "groupset" });
    }
  },

  mounted() {
    this.mounted = true
    this.$store.dispatch("data/fetchRecords", { module: "groupset" });
  },

  destroyed() {
    this.mounted = false
  }
};
</script>

<style scoped>

</style>